var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07292 7.89542C5.39292 10.4896 7.515 12.6117 10.1138 13.9317L12.1304 11.9104C12.3825 11.6583 12.7446 11.585 13.0608 11.6858C14.0875 12.025 15.1921 12.2083 16.3333 12.2083C16.8421 12.2083 17.25 12.6163 17.25 13.125V16.3333C17.25 16.8421 16.8421 17.25 16.3333 17.25C7.72583 17.25 0.75 10.2742 0.75 1.66667C0.75 1.15792 1.1625 0.75 1.66667 0.75H4.875C5.38375 0.75 5.79167 1.15792 5.79167 1.66667C5.79167 2.80792 5.975 3.9125 6.31417 4.93917C6.415 5.25542 6.34167 5.6175 6.08958 5.86958L4.07292 7.89542Z",
    fill: "#356966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNew);
export default __webpack_public_path__ + "static/media/phone_new.d68b5b1039622e6355bde010cb250562.svg";
export { ForwardRef as ReactComponent };